import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import TaskChangeStatusManageModal from 'components/Tasks/_actions/TaskChangeStatusManageModal';
import UserBanManageModal from 'components/Users/_actions/UserBanManageModal';
import { selectConcatRoles } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { t } from 'utils/translates';

const ManageBlock = props => {
  const { taskModel, userModel, onRefreshParentContent } = props;
  const [
    isOpenTaskChangeStatusManageModal,
    setIsOpenTaskChangeStatusManageModal
  ] = useState(false);
  const [isOpenUserBanManageModal, setIsOpenUserBanManageModal] = useState(
    false
  );
  const concatRoles = useSelector(state => selectConcatRoles(state));

  return (
    <React.Fragment>
      {concatRoles !== '' ? (
        <div className="panel panel-default border-t">
          <div className="panel-body">
            <div className="panel-title panel-title_xs text-center">
              {t('Администратирование')}
            </div>
            <div>
              {taskModel ? (
                <React.Fragment>
                  <TaskChangeStatusManageModal
                    isOpen={isOpenTaskChangeStatusManageModal}
                    onClose={() => setIsOpenTaskChangeStatusManageModal(false)}
                    modalIndex={taskModel.id}
                    taskModel={taskModel}
                    onRefreshParentContent={onRefreshParentContent}
                  />
                  <UserBanManageModal
                    isOpen={isOpenUserBanManageModal}
                    onClose={() => setIsOpenUserBanManageModal(false)}
                    modalIndex={taskModel.id}
                    userId={taskModel.ownerId}
                    onRefreshParentContent={onRefreshParentContent}
                  />
                  <a
                    href=""
                    className="btn btn-default btn-block"
                    data-toggle="modal"
                    title="Заблокировать задание"
                    onClick={() => setIsOpenTaskChangeStatusManageModal(true)}
                  >
                    <i className="fa fa-ban fa-fw" /> {t('Забл. задание')}
                  </a>
                  <a
                    href=""
                    className="btn btn-default btn-block"
                    data-toggle="modal"
                    title="Заблокировать заказчика"
                    onClick={() => setIsOpenUserBanManageModal(true)}
                  >
                    <i className="fa fa-user-times fa-fw" />{' '}
                    {t('Забл. заказчика')}
                  </a>
                </React.Fragment>
              ) : null}
              {userModel ? (
                <React.Fragment>
                  <UserBanManageModal
                    isOpen={isOpenUserBanManageModal}
                    onClose={() => setIsOpenUserBanManageModal(false)}
                    modalIndex={userModel.id}
                    userId={userModel.id}
                    onRefreshParentContent={onRefreshParentContent}
                  />
                  <a
                    href=""
                    className="btn btn-default btn-block"
                    data-toggle="modal"
                    title="Заблокировать аккаунт"
                    onClick={() => setIsOpenUserBanManageModal(true)}
                  >
                    <i className="fa fa-user-times fa-fw" />{' '}
                    {t('Забл. аккаунт')}
                  </a>
                </React.Fragment>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </React.Fragment>
  );
};

ManageBlock.defaultProps = {
  taskModel: null,
  userModel: null,
  onRefreshParentContent: () => {}
};

ManageBlock.propTypes = {
  taskModel: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    ownerId: PropTypes.number
  }),
  userModel: PropTypes.shape({
    id: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired
  }),
  onRefreshParentContent: PropTypes.func
};

export default ManageBlock;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/TaskViewAsExecutor/ManageBlock/index.js